import { render, staticRenderFns } from "./GiveCouponRecords.vue?vue&type=template&id=31cbcdc0"
import script from "./GiveCouponRecords.vue?vue&type=script&lang=js"
export * from "./GiveCouponRecords.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "GiveCouponRecords.vue"
export default component.exports